import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {map} from 'rxjs/operators';
import * as _ from 'lodash';
import { StoreInfo } from 'src/domain/storeInfo';
import { Router } from '@angular/router';
import { GlobalService } from './global.service';
import { SearchResult } from 'src/domain/searchResults/searchResult';
import { TranslateService } from '@ngx-translate/core';
import { Permits } from 'src/domain/enums/Permits.enum';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  endpoint = this.globalService.endpoint;

  headers = new HttpHeaders().set('Content-Type', 'application/json');

  loginError: string;

  constructor(private http: HttpClient, public router: Router, private globalService: GlobalService, private translate: TranslateService) { 
    this.gestisciAbilitazioni();
 
      
  }

  getHeaders() {
    
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization:'Bearer ' +  localStorage.getItem('login_token')
    });
  }

  getFinalHeaders() {

    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization:'Bearer ' +  localStorage.getItem('login_token')
    });
  }

  logininfo(id_user) {
    const url = this.endpoint + 'users/loginInfo';
    const params: any = {
      id_user : id_user
    };
    return this.http.post<any>(url, params, {headers: this.getHeaders()});

  }

  /**
   * Inserisce o modifica un task
   * @param task - il task da inserire/modificare
   * @returns 
   */
   getUsers() {
    const url = this.endpoint + 'users/searchallutenti';
    const params = {
      PageSize: 1000
    }
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      this.updateToken(result.TokenAnswer);
      return result;
    }, error => {
      console.error(error);
    }));
  }

  
  getUserHp(id_role) {

  }

  login(model: any) {
    localStorage.removeItem('login_token');
    localStorage.removeItem('logininfo');
    return this.http.post(this.endpoint + 'auth/login', model).pipe(
      map((response: any) => {
        const user = response;
        if (response.Errore) {
          this.loginError = response.Errore;
        } else {
          this.loginError = '';
          this.globalService.loggedUserPassword=model.password;
          this.globalService.loggedUser=response['user'];
          localStorage.setItem('loggedUser',  JSON.stringify(this.globalService.loggedUser));
          
  
  
          // chiama i compoenti homepage
       //    this.getUserHp(this.globalService.loggedUserId_Role).subscribe((res)=>{
       //      console.log(res);
       //    });

          if (user && user.TokenAnswer !== '') {
            localStorage.setItem('login_token', user.TokenAnswer);
              this.updateToken(user.TokenAnswer);
          }
        }
      })
    );
  }


  /**
   * Serve specificatamente per effettuare il login secondario
   */
  loginSecondario(un: string, pw: string) {
    const secondaryLoginParams = {
      username : un,
      password : pw
    }

    const url = this.endpoint + 'users/login';
    return this.http.post<SearchResult>(url, secondaryLoginParams, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      this.updateToken(result.TokenAnswer);
      return result;
    }));


  }

  logout(curl='') {

    // rimuovo il token
    localStorage.removeItem('login_token');
  
  
  

    this.globalService.resetService();
    this.globalService.impostazioni = [];

    if(curl!=''){
      if(!sessionStorage.getItem('redirect'))
        sessionStorage.setItem('redirect',curl);
    }
    this.router.navigate(['']);

  }

  public get loggedIn(): boolean {
    return localStorage.getItem('login_token') !== null;
  }

  public updateToken(token: string) {
    if(token){
      localStorage.setItem('login_token', token);
    }
  }

  public cambiaPasswordPrimaria(params: any) {
    const url = this.endpoint + 'users/cambiapasswordprimaria';
    return this.http.post<StoreInfo>(url, params, {headers: this.globalService.getHeaders()});
  }
  
  public resetPasswordPrimaria(params: any) {
    const url = this.endpoint + 'users/resetpassword';
    return this.http.post<StoreInfo>(url, params, {headers: this.globalService.getHeaders()});
  }
  
  
  
  public cambiaPasswordSecondaria(params: any) {
    const url = this.endpoint + 'users/cambiapassword';
    return this.http.post<StoreInfo>(url, params, {headers: this.globalService.getHeaders()});
  }

  gestisciAbilitazioni() {

  
    if(this.globalService.logininfo){
      this.globalService.permits = [];
      if(this.globalService.logininfo.ABI_ARCCASSE==1){
        this.globalService.permits.push(Permits.ARCCASSE);
      }
      if(this.globalService.logininfo.ABI_ARCDOC==1){
        this.globalService.permits.push(Permits.ARCDOC);
      }
      if(this.globalService.logininfo.ABI_ARCFATT==1){
        this.globalService.permits.push(Permits.ARCFATT);
      }
      if(this.globalService.logininfo.ABI_AG==1){
        this.globalService.permits.push(Permits.AG);
      }
      if(this.globalService.logininfo.ABI_ARCMAN==1){
        this.globalService.permits.push(Permits.ARCMAN);
      }

      if(this.globalService.logininfo.ABI_SIGN==1){
        this.globalService.permits.push(Permits.SIGN);
      }
      if(this.globalService.logininfo.ARKIDATA==1){
        this.globalService.permits.push(Permits.ARKIDATA);
      }
      this.globalService.permits.push(Permits.ARKIDATA);
      if(this.globalService.logininfo.TURNIWEB==1){
        this.globalService.permits.push(Permits.TURNIWEB);
      }
      if(this.globalService.logininfo.BUDGET==1){
        this.globalService.permits.push(Permits.BUGDET);
      }
      if(this.globalService.logininfo.ASSUNZIONI==1){
        this.globalService.permits.push(Permits.ASSUNZIONI);
      }
      if(this.globalService.logininfo.F_SURVEYS_GEST==1){
        this.globalService.permits.push(Permits.SURVEYS_GEST);
      }
      if(this.globalService.logininfo.F_SURVEYS_REP==1){
        this.globalService.permits.push(Permits.SURVEYS_REP);
      }
      if(this.globalService.logininfo.F_SURVEYS_SEND==1){
        this.globalService.permits.push(Permits.SURVEYS_SEND);
      }
      

      
      if(this.globalService.loggedUser.id_role!=96){
        this.globalService.permits.push(Permits.CHECKLIST);
      }
     
      if(
        (this.globalService.loggedUser.id==112)   // GALLORINI
        ||(this.globalService.loggedUser.id==5952) // REACTIVE
        ||(this.globalService.loggedUser.id==129) // IUCULANO
        ||(this.globalService.loggedUser.id==312) // IUCULANO
      ){
        this.globalService.permits.push(Permits.MONITORTV);
      }


      if(this.globalService.logininfo.MENSA_INS_MENU==1){
        this.globalService.permits.push(Permits.MENSA_INS_MENU);
      }
      
      if(this.globalService.logininfo.MENSA_COSTI==1){
        this.globalService.permits.push(Permits.MENSA_COSTI);
      }
      
      if(this.globalService.logininfo.MENSA_VIEW_PREN==1){
        this.globalService.permits.push(Permits.MENSA_VIEW_PREN);
      }
      
      

    }
    
    this.generateMenu();   
   
      
  }


  private generateMenu() {

      this.globalService.menuItems = [

        { id: 'Home', label: "Dashboard", icon: 'fas fa-home', routerLink: '/dashboard', command: (event) => {this.globalService.showMenu = false} },
        
        { id: 'Amministrazione', label: 'Amministrazione', icon: 'fas fa-lock', items: [
          { label: 'Budget e controllo di gestione', routerLink: '/java/budget/login/LogonServlet',  
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.BUGDET), target:'_blank' },
          { label: 'Investimenti', routerLink: '/java/budget/login/LogonServletBG2021?oper=1',    
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.BUGDET), target:'_blank' },  
          { label: 'ArkiCasse', routerLink: '/java/arkicasse/login/LogonServletCasse?oper=1', 
          command: (event) => {this.globalService.showMenu = false},  visible: this.globalService.permits.includes(Permits.ARCCASSE), target:'_blank' },
          { label: 'ArkiFatt', routerLink: '/java/arkifatt/login/LogonServletAF?oper=1', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.ARCFATT), target:'_blank' },
          { label: 'Arkirec', routerLink: '/java/arkirec/login/LogonServletRec?oper=1',
          command: (event) => {this.globalService.showMenu = false}, target: '_blank' },
          { label: 'Mail Fatture Ospiti',   routerLink: '/java/arkiweb/login/LogonServletAw?oper=99&redirectS=ServletDocumenti',   
          command: (event) => {this.globalService.showMenu = false},  target:'_blank' },          
          { label: 'Inserimento Fornitori', routerLink: '/java/arkifatt/login/LogonServletAF?oper=6', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.ARCFATT), target:'_blank' }, 
          { label: 'Contratti Fornitori', routerLink: '/java/arkifatt/login/LogonServletAF?oper=10', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.ARCFATT), target:'_blank' },                       
          { label: 'Cruscotto', routerLink: '/java/arkiweb/login/LogonServletAw?oper=1&redirectS=ServletReportArki', 
          command: (event) => {this.globalService.showMenu = false}, target:'_blank' },
          { label: 'Indicatori Annuali', routerLink: '/java/arkiweb/login/LogonServletAw?oper=2&redirectS=ServletReportArki', 
          command: (event) => {this.globalService.showMenu = false}, target:'_blank' }, 
      ]},   

      {id:'HR', label: 'Personale - HR', icon: 'fas fa-user-friends', items: [
          { label: 'Turni Web', routerLink: '/java/gper/login/LogonServletgper?oper=98', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.TURNIWEB), target:'_blank' },
          { label: 'Recruiting', routerLink: '/java/assunzioni/login/LogonServletAs?oper=1', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.TURNIWEB), target:'_blank' },
          { label: 'Turno', routerLink: '/java/arkiweb/login/LogonServletAw?oper=3&redirectS=ServletUtenti', 
          command: (event) => {this.globalService.showMenu = false}, target:'_blank' },
      ]},
      
      {id:'Gestione', label: 'Gestione Strutture', icon: 'fas fa-house-user', items: [
   
         { label: 'Arkiman', routerLink: '/java/arkiman/login/LogonServletMAN?oper=1', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.ARCMAN), target:'_blank' },
          { label: 'Arkiguest', routerLink: '/java/arkiguest/login/LogonServletAG?oper=1', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.AG), target:'_blank' },   
          { label: 'Presenze Ospiti', routerLink: '/java/arkiweb/login/LogonServletAw?oper=1&redirectS=ServletPresOspiti', 
          command: (event) => {this.globalService.showMenu = false}, target:'_blank' },                                        
          { label: 'Segnalazioni', routerLink: '/java/sign/login/LogonServletSign?oper=1', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.SIGN), target:'_blank' },
          { label: 'Non Conformità', routerLink: '/java/sign/login/LogonServletSign?oper=7', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.SIGN), target:'_blank' },
          { label: 'Ticket', routerLink: '/java/arkiweb/login/LogonServletAw?oper=3&redirectS=ServletTicket', 
          command: (event) => {this.globalService.showMenu = false}, target:'_blank' },
          { label: 'Tasks', routerLink: '/java/arkiweb/login/LogonServletAw?oper=2&redirectS=ServletTask', 
          command: (event) => {this.globalService.showMenu = false}, target:'_blank' },
          { label: 'Rentri', routerLink: 'java/arkiweb2.homeip.net/rentri', 
            command: (event) => {this.globalService.showMenu = false} },
   
      ]},
      
      {id:'Archivi', label: 'Archivi', icon: 'fas fa-folder-open', items: [
          { label: 'Arcdoc', routerLink: '/java/arcdoc/login/LogonServletAD?oper=1', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.ARCDOC), target:'_blank' },
          { label: 'Arkidata', routerLink: '/java/arkidata/login/LogonServletAD?oper=1', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.ARKIDATA), target:'_blank' },
          { label: 'Documenti', routerLink: '/java/arkiweb/login/LogonServletAw?oper=1&redirectS=ServletDocumenti', 
          command: (event) => {this.globalService.showMenu = false}, target:'_blank' },
          { label: 'Mansionari', routerLink: '/java/arkiweb/login/LogonServletAw?oper=3&redirectS=ServletDocumenti&f_cat=45', 
          command: (event) => {this.globalService.showMenu = false},  target:'_blank' },
          { label: 'Moduli', routerLink: '/java/arkiweb/login/LogonServletAw?oper=3&redirectS=ServletDocumenti&f_cat=46', 
          command: (event) => {this.globalService.showMenu = false},  target:'_blank' },
          { label: 'Procedure', routerLink: '/java/arkiweb/login/LogonServletAw?oper=3&redirectS=ServletDocumenti&f_cat=48', 
          command: (event) => {this.globalService.showMenu = false},  target:'_blank' },
          { label: 'Protocolli', routerLink: '/java/arkiweb/login/LogonServletAw?oper=3&redirectS=ServletDocumenti&f_cat=49',
           command: (event) => {this.globalService.showMenu = false},  target:'_blank' },
          { label: 'Organigrammi', routerLink: '/java/arkiweb/login/LogonServletAw?oper=3&redirectS=ServletDocumenti&f_cat=47', 
          command: (event) => {this.globalService.showMenu = false},  target:'_blank' },
          { label: 'Elenchi', routerLink: '/java/arkiweb/login/LogonServletAw?oper=3&redirectS=ServletDocumenti&f_cat=44', 
          command: (event) => {this.globalService.showMenu = false},  target:'_blank' },
          { label: 'Guide', routerLink: '/java/arkiweb/login/LogonServletAw?oper=100&redirectS=ServletDocumenti', 
          command: (event) => {this.globalService.showMenu = false}, target:'_blank' },
          { label: 'Policy', routerLink: '/java/arkiweb/login/LogonServletAw?oper=3&f_cat=2&redirectS=ServletDocumenti', 
          command: (event) => {this.globalService.showMenu = false},  target:'_blank' },
          { label: 'Circolari', routerLink: '/java/arkiweb/login/LogonServletAw?oper=3&f_cat=32&redirectS=ServletDocumenti', 
          command: (event) => {this.globalService.showMenu = false},  target:'_blank' },
          { label: 'Verbali', routerLink: '/java/arkiweb/login/LogonServletAw?oper=3&f_cat=41&f_anno=2023&redirectS=ServletDocumenti', 
          command: (event) => {this.globalService.showMenu = false},  target:'_blank' },
        ]},

        /*
        { id:'Sharepoint', label: 'Sharepoint', icon: 'fas fa-link', items: [
            { label: 'Mailing List', routerLink: '/java/http://server09dc/GRUPPO%20ARKIGEST/Forms/AllItems.aspx?RootFolder=%2FGRUPPO%20ARKIGEST%2FELENCHI%2FMAIL%5Fe%5FMAILING%5FLIST&FolderCTID=0x012000BA3B7416E7CAE14E94484D44B505F344&View={4217D9DF-D5AA-4925-913E-48069E03EAB3', 
            command: (event) => {this.globalService.showMenu = false}, target:'_blank' },                 
            { label: 'La Villa', routerLink: 'java/http://server09dc/GRUPPO%20LA%20VILLA/Forms/AllItems.aspx', 
            command: (event) => {this.globalService.showMenu = false}, target:'_blank' },
            { label: 'Holding', routerLink: 'java/http://server09dc/GRUPPO%20ARKIGEST/Forms/AllItems.aspx', 
            command: (event) => {this.globalService.showMenu = false}, target:'_blank' },
            { label: 'Eukedos', routerLink: 'java/http://server09dc/GRUPPO%20EUKEDOS/Forms/AllItems.aspx', 
            command: (event) => {this.globalService.showMenu = false},target:'_blank' }, 
        ]},
        */

        {id:'Monitors', label: 'Monitors', icon: 'fas fa-tv',visible: this.globalService.permits.includes(Permits.MONITORTV),
           items: [
          { label: 'Monitors', routerLink: '/dashboard/monitors', 
          command: (event) => {this.globalService.showMenu = false}},
          { label: 'Tipologie monitors', routerLink: '/dashboard/tipimonitors', 
            command: (event) => {this.globalService.showMenu = false} },                 
          { label: 'Playlists', routerLink: '/dashboard/monitors/playlists', 
          command: (event) => {this.globalService.showMenu = false} },  
          { label: 'Regole', routerLink: '/dashboard/monitors/rules', 
            command: (event) => {this.globalService.showMenu = false} },   
          { label: 'Setup', routerLink: '/dashboard/monitors/setup', 
            command: (event) => {this.globalService.showMenu = false} },   
       
        ]},

        {id:'Gestionemensa', label: 'Gestione mensa', icon: 'fas fa-utensils',
          visible: this.globalService.permits.includes(Permits.MENSA_INS_MENU) 
          || this.globalService.permits.includes(Permits.MENSA_COSTI)
          || this.globalService.permits.includes(Permits.MENSA_VIEW_PREN),
          items: [
          { label: 'Programmazione Mensa', routerLink: '/dashboard/gestionemensa/programma', 
          command: (event) => {this.globalService.showMenu = false},
           visible:this.globalService.permits.includes(Permits.MENSA_INS_MENU) },
         // { label: 'Menù per giorno', routerLink: '/dashboard/gestionemensa/programmazione', 
       //   command: (event) => {this.globalService.showMenu = false},
        //   visible:this.globalService.permits.includes(Permits.MENSA_INS_MENU) },
         { label: 'Ricette', routerLink: '/dashboard/gestionemensa/ricette', 
          command: (event) => {this.globalService.showMenu = false},
           visible:this.globalService.permits.includes(Permits.MENSA_INS_MENU) },  

          { label: 'Prenotazioni', routerLink: '/dashboard/gestionemensa/prenotazioni', 
          command: (event) => {this.globalService.showMenu = false} },  
          
          { label: 'Posti liberi', routerLink: '/dashboard/gestionemensa/programmazione-calendar', 
          command: (event) => {this.globalService.showMenu = false},
            visible:this.globalService.permits.includes(Permits.MENSA_VIEW_PREN) },         
            
          { label: 'Capienze', routerLink: '/dashboard/gestionemensa/capienze', 
          command: (event) => {this.globalService.showMenu = false},
            visible:this.globalService.permits.includes(Permits.MENSA_VIEW_PREN) },         
      

          { label: 'Sospensioni', routerLink: '/dashboard/gestionemensa/sospensioni', 
          command: (event) => {this.globalService.showMenu = false},
            visible:this.globalService.permits.includes(Permits.MENSA_VIEW_PREN) },         

          { label: 'Impostazioni', routerLink: '/dashboard/gestionemensa/setup', 
            command: (event) => {this.globalService.showMenu = false},
            visible:this.globalService.permits.includes(Permits.MENSA_COSTI)
          },        
       ]},

        {id: 'Surveys', label: 'Surveys', icon: 'fas fa-poll', 
        visible: this.globalService.permits.includes(Permits.SURVEYS_GEST) ||
        this.globalService.permits.includes(Permits.SURVEYS_REP) ||
        this.globalService.permits.includes(Permits.SURVEYS_SEND) , items: [
          { label: 'Mandatory schema', routerLink: '/dashboard/surveys/survey-startup-models', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.SURVEYS_GEST)},
          { label: 'Models', routerLink: '/dashboard/surveys/survey-models', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.SURVEYS_GEST)},
          { label: 'Surveys', routerLink: '/dashboard/surveys/surveys', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.SURVEYS_GEST)},
          { label: 'Residencies', routerLink: '/dashboard/surveys/rsa', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.SURVEYS_GEST)},
          { label: 'Targets', routerLink: '/dashboard/surveys/targets', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.SURVEYS_GEST)},
          { label: 'Email campaigns', routerLink: '/dashboard/surveys/email-campaigns', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.SURVEYS_SEND)},
          { label: 'SMS Campaigns', routerLink: '/dashboard/surveys/sms', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.SURVEYS_SEND)},
       
          { label: 'Results', routerLink: '/dashboard/surveys/surveys-results', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.SURVEYS_REP)},
   
          { label: 'Powerpoint Results', routerLink: '/dashboard/surveys/surveys-results-pptx', 
          command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.SURVEYS_REP)},
   
  
      ]},

        { 
            label: 'Firme Documenti', 
            icon: 'fas fa-file-signature',
            // Usiamo il prefisso 'java/' che abbiamo scoperto funzionare
            routerLink: 'java/https://lavilladev.homeip.net/FIRME_DOCUMENTI/', 
            target: '_blank',
            command: (event) => { 
                this.globalService.showMenu = false;
                // Se il routerLink dovesse fare i capricci perché è un "padre", 
                // questa riga qui sotto è il colpo di grazia che forza l'apertura
                if (!event.item.items) { 
                    window.open('https://lavilladev.homeip.net/FIRME_DOCUMENTI/', '_blank'); 
                }
            }
        },



      {id: 'Checklist', label: 'Checklist', icon: 'fas fa-poll', visible: this.globalService.permits.includes(Permits.CHECKLIST), items: [
        { label: 'Modelli', routerLink: '/dashboard/checklists/checkl-models', 
        command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.CHECKLIST)},
        { label: 'Checklist', routerLink: '/dashboard/checklists/checkl', 
        command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.CHECKLIST)},
        { label: 'Risultati', routerLink: '/dashboard/checklists/checkl-results', 
        command: (event) => {this.globalService.showMenu = false}, visible: this.globalService.permits.includes(Permits.CHECKLIST)},

      ]},

      {id:'Utilities', label: 'Utilities', icon: 'fas fa-bars', items: [
        { label: 'Workflow', routerLink: '/java/arkiweb/login/LogonServletAw?oper=3&redirectS=ServletProgetti', 
        command: (event) => {this.globalService.showMenu = false},  target:'_blank' },
      { label: 'Setup hp', routerLink: '/dashboard/setup-hp/list', 
      command: (event) => {this.globalService.showMenu = false},  target:'_blank' },                 
      ]},

    ];
    this.filterMenuByRole();

  }

  filterMenuByRole(){
   if(this.globalService.loggedUser){
    if(this.globalService.loggedUser.id_role==96){
      let index = this.globalService.menuItems.length - 1;
      while (index >= 0) {
        if (this.globalService.menuItems[index].id !== 'Surveys') {
          this.globalService.menuItems.splice(index, 1);
        }
        index -= 1;
      }
    }
   } 
  }
  /**
   * Recupera le abilitazioni
   */
  getAbilitazioni(idGruppo: number) {
    const url = this.endpoint + 'settings/infoabilitazioni';
    const params: any = {
      PageSize : 1000,
      IdGruppo: idGruppo
    };
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      this.updateToken(result.TokenAnswer);
      return result;
    }));
  }

  /**
   * Recupera i moduli attivi per l'utente
   */
  getModuliAttivi() {
    const url = this.endpoint + 'settings/infomoduli';
    const params = {};
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      this.updateToken(result.TokenAnswer);
      return result;
    }));
  }



  getkpi(params){
    const url = this.endpoint + 'hp/gethp';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }
  

  // APIs
  getHeadersLogout(token: string){
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization:'Bearer ' +  token
    });
  }

}
